export class RequiredConditionalMandatory {
    constructor(
        requiredConditionalMandatoryId: number,
        eventTypeGroupId: number,
        requiredPreviousTypeId: number,
        notAfterEventTypeId: number,
        requiredPreviousTypeName: string,
        notAfterEventTypeName: string
    ) {
        this.requiredConditionalMandatoryId = requiredConditionalMandatoryId;
        this.eventTypeGroupId = eventTypeGroupId;
        this.requiredPreviousTypeId = requiredPreviousTypeId;
        this.notAfterEventTypeId = notAfterEventTypeId;
        this.requiredPreviousTypeName = requiredPreviousTypeName;
        this.notAfterEventTypeName = notAfterEventTypeName;
    }
    requiredConditionalMandatoryId: number;
    eventTypeGroupId: number;
    requiredPreviousTypeId: number;
    notAfterEventTypeId: number;
    requiredPreviousTypeName: string;
    notAfterEventTypeName: string;
}
